<template>
  <div>
    <a-button @click="changeRefValue">修改ref值</a-button>
    <a-button @click="changeReactiveValue">修改reactive值</a-button>
    <div>
<!--      <p>str: {{str}}</p>-->
<!--      <p>obj: {{obj}}</p>-->
<!--      <p>list: {{list}}</p>-->

<!--      <p>formState: {{formState}}</p>-->
<!--      <p>arr: {{arr}}</p>-->
    </div>
  </div>
</template>

<script setup>
// import { parentEmit, str, list, obj, formState, arr } from './parent';
// import { child } from './child';
import { formState } from './child';
// import * as myParent from './parent';
// console.log('myParent: ', myParent);
console.log('formState: ', formState);

// console.log('parentEmit: ', parentEmit);
//
// function changeRefValue () {
//   // str = '字符串';// 赋值无效
//   // list = ['我的', '你的']; // 赋值无效
//   // obj = { a: 10, b: 20 }; // 赋值无效
//   str.value = '字符串';// 生效
//   list.value = ['我的', '你的'];// 生效
//   obj.value = { a: 10, b: 20 };
// }
//
// function changeReactiveValue () {
//   // formState = { a: 20, b: 30 }; // 赋值无效
//   // arr = ['1', '2']; // 赋值无效
//   arr[0] = '1';// 生效
//   arr[1] = '2';
//
//   let data = { a: 20, b: 30 };
//   for (let item in formState) {
//     if (data.hasOwnProperty(item)) {
//       formState[item] = data[item]; // 生效
//     }
//   }
// }
</script>
